var map = {
	"./Ashinaga.jpg": 2089,
	"./Nagoya-visual.jpg": 3895,
	"./Osaka-visual.jpg": 6595,
	"./company-outlook.jpg": 8072,
	"./hukuoka.jpg": 8187,
	"./sendai.jpg": 8819,
	"./tokyo.jpg": 7773,
	"./会社LOGOvisual.webp": 8512
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4268;